import React from 'react';

import { Text } from 'Modules/ui';

import { translate } from './TranslateComponent';


export const notificationRenderer = translate('notifications')(
    ({ content, t }) => (
        <Text component='span' textType='light'>
            {t(content)}
        </Text>
    ),
);
